import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/inclusion.vue'),
          props: true
    },
    {
      path: '/credits',
      name: 'credits',
      component: () => import('./views/Credits.vue')
    },
    {
      path: '/host',
      name: 'host',
      component: () => import('./views/CaptionHost.vue')
    },
    {
      path: '/join/:sessionname?',
      name: 'join',
      component: () => import('./views/CaptionJoin.vue'),
      props: true
    },
    {
      path: '/joinlff',
      name: 'joinlff',
      component: () => import('./views/CaptionJoinlff.vue'),
      props: true
      },
      {
          path: '/inclusion',
          name: 'inclusion',
          component: () => import('./views/inclusion.vue'),
          props: true
      }
  ]
})
